<script>
	import { walletAddress } from '$lib/wallet/store';
	import { version } from '$app/environment';
	import Tooltip from '$lib/tooltip/Tooltip.svelte';
	import { onDestroy } from 'svelte';

	let fm_url = '';

	const walletAddressEventListener = walletAddress.subscribe(async () => {
		const fm_subdomain = 'feedback.polynomial.fi';
		const jwtToken = await createJwtToken();
		fm_url = $walletAddress ? `http://${fm_subdomain}/sso/${jwtToken}` : `http://${fm_subdomain}`;
	});

	onDestroy(walletAddressEventListener);

	async function createJwtToken() {
		const KJUR = (await import('jsrsasign')).KJUR;

		const header = JSON.stringify({ alg: 'HS256', typ: 'JWT' });
		const payload = JSON.stringify({
			full_name: '',
			email: $walletAddress
		});
		const secret = 'ARTb_IPesaHrxVNwJtReNQ';
		return KJUR.jws.JWS.sign('HS256', header, payload, secret);
	}

	async function getStatus() {
		const res = await fetch(`https://polynomial.instatus.com/summary.json`);
		const text = await res.json();

		if (res.ok) {
			return text;
		} else {
			throw new Error(text);
		}
	}

	let promise = getStatus();
</script>

<div
	class=" bg-fx-black text-fx-grey-300 px-5 py-2 grid grid-cols-3 text-xs items-center bottom-0 border-t border-fx-grey-500"
>
	<div class="flex gap-4">
		{#await promise}
			<div class="border border-fx-grey-500 bg-fx-grey-800 py-2 px-2 text-fx-grey-100 rounded-md">
				Loading..
			</div>
		{:then instatus}
			<a href={instatus.page.url} target="_blank" rel="noreferrer">
				<div
					class="border border-fx-grey-500 bg-fx-grey-800 py-2 px-2 text-fx-grey-100 rounded-md flex gap-2"
				>
					{#if instatus.page.status === 'UNDERMAINTENANCE'}
						Maintenance
					{:else if instatus.page.status === 'HASISSUES'}
						Incident
					{:else if instatus.page.status === 'UP'}
						Operational
					{/if}
				</div>
			</a>
		{:catch error}
			<p style="color: red">{error.message}</p>
		{/await}
	</div>
	<div class="text-center">
		<Tooltip
			header="Version: 1.{version}"
			title="YYYY-MM-DD is a better format for date than either MM-DD-YYYY or DD-MM-YYYY because it's more logical, easier to identify, sort, and also aligns with standard time format."
		>
			<span class="font-semibold">Version: 1.{version}</span>
		</Tooltip>
	</div>

	<div class="flex justify-end items-center gap-2">
		<a href="https://twitter.com/polynomialfi" target="_blank" rel="noreferrer">
			<img src={'social/twitter-grey.png'} loading="lazy" alt="twitter" class="w-5 h-4 mr-8" />
		</a>
		<a href="https://discord.gg/polynomial" target="_blank" rel="noreferrer">
			<img src={'social/discord-grey.png'} loading="lazy" alt="twitter" class="w-5 h-4 mr-6" />
		</a>
		<a href={fm_url} target="_blank" rel="noreferrer">
			<div class="border border-fx-grey-500 bg-fx-grey-800 py-2 px-2 text-fx-grey-100 rounded-md">
				Send feedback
			</div>
		</a>
	</div>
</div>
